import { AA as AAShieldStarter } from "@utils/adobeAnalyticsSS";

const trackOnLoad = (formName: string) => {
    const AA = AAShieldStarter.getInstance();
    const { form, acquisition } = AA.digitalData;
    form.name = formName;
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";
    AA.trackPageLoad({ form, acquisition });
  };

  const trackOnNeedHelpStart = (formName: string) => {
    const AA = AAShieldStarter.getInstance();
    const { form } = AA.digitalData;
    form.name = formName;
    form.error.fieldLabels = [];
    form.error.messages = [];
    form.error.numErrors = "0";
    AA.trackPageStart({ form });
  };

  // const trackErrorCode = (formName:string, )

  export {trackOnLoad,trackOnNeedHelpStart}